// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3R3QR","actionsCol":"EnrolledClinics_actionsCol__3Q2Gt"};